<template>
    <div class="cancelBox" :class="client == 'iOS' ? 'iosClass' : ''">
        <ul>
            <li class="pay">
                <p>{{ $t("diamondDrop1") }}</p>
            </li>
            <li class="pay">
                <p>{{ $t("diamondDrop2") }}</p>
            </li>
            <li class="pay">
                <p>{{ $t("diamondDrop3") }}</p>
            </li>
            <li class="pay">
                <p>{{ $t("diamondDrop4") }}</p>
            </li>
        </ul>
    </div>
   
  </template>
  
  <script>
  export default {
    name: "cancelAccount",
    data() {
      return {
        langType: "",
      client:''
      };
    },
    created() {
        this.langType = this.$route.query.langType;
        this.language()
        this.judgeClient()
    },
    mounted() {
    },
    methods: { 
        // 判断平台
        judgeClient() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
            this.client = 'iOS';
        } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
            this.client = 'Android';
        } else {
            this.client = 'PC';
        }
        return this.client;
        },
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else if (langs == "fr") {
                this.$i18n.locale = "fr"
            } else if (langs == "id") {
                this.$i18n.locale = "id"
            } else if (langs == "ms") {
                this.$i18n.locale = "ms"
            } else {
                this.$i18n.locale = "en";
            }
            document.title = this.$t('prettyNumber.title')
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
  html[lang="ar"] .cancelBox {
  -webkit-transform: rotateY(180deg);
}
html[lang="ar"] .cancelBox ul {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .cancelBox{
    width: 6.4rem;
    padding: 0.4rem 0.28rem;
    box-sizing: border-box;
  }

    li{
        margin-bottom: 0.32rem;
        font-size: 0.26rem;
        font-family: "Montserrat";
        color: #262427;
        line-height: 0.44rem;
        header{
            font-weight: bold;
            margin-bottom: 0.08rem;
        }
        p{

            /* font-weight: 500; */
        }
    }
    footer{
        margin-bottom: 0.32rem;
        font-size: 0.2rem;
        font-family: "PingFang SC";
        color: #000;
        line-height: 0.3rem;

    }
    .iosClass{
        padding-top: 0.88rem;
    }
  </style>
  